import { render, staticRenderFns } from "./SurveyIssues.vue?vue&type=template&id=798e5d80&scoped=true"
import script from "./SurveyIssues.vue?vue&type=script&lang=js"
export * from "./SurveyIssues.vue?vue&type=script&lang=js"
import style0 from "./SurveyIssues.vue?vue&type=style&index=0&id=798e5d80&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798e5d80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798e5d80')) {
      api.createRecord('798e5d80', component.options)
    } else {
      api.reload('798e5d80', component.options)
    }
    module.hot.accept("./SurveyIssues.vue?vue&type=template&id=798e5d80&scoped=true", function () {
      api.rerender('798e5d80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/List/SurveyIssues.vue"
export default component.exports